import { render } from "./ApiDoc.vue?vue&type=template&id=825fa532&scoped=true"
import script from "./ApiDoc.vue?vue&type=script&lang=js"
export * from "./ApiDoc.vue?vue&type=script&lang=js"

import "./ApiDoc.vue?vue&type=style&index=0&id=825fa532&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-825fa532"]])

export default __exports__